<template>
    <div class="Frame">
        <div class="ShopperTable Table">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                    <tr class="TableHead">
                        <th scope="col" class="STProductName">
                            <div class="Form">
                                <div class="FormRow">
                                    <div class="FormBoxWide FormCheckBox">
                                        <div class="Label">
                                            <a href="javascript:void(0)" class="SortingButton"><span>{{ this.risorse["Nome"] }}</span> <img src="/images/SortingIcon.png" srcset="/images/SortingIconRetina.png 2x" alt=""/></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </th>
                        <th scope="col" class="STProductColor"><span>{{ this.risorse["TabVarColore"] }}</span></th>
                        <th scope="col" class="STProductSize"><span>{{ this.risorse["TabVarTaglia"] }}</span></th>
                        <th scope="col" class="STProductCode">{{ this.risorse["TabVarCodice"] }}</th>
                        <th scope="col" class="STUnitPrice">{{ this.risorse["TabVarPrezzoUn"] }}</th>
                        <th scope="col" class="STQuantity"><span>{{ this.risorse["TabVarQty"] }}</span></th> 
                        <th scope="col" class="STSubtotal">{{ this.risorse["TabVarSub"] }}</th>
                    </tr>
                    <CatalogCartRow  v-for="articolo in this.listaArticoli" 
                        :key="articolo.CodiceArticolo" 
                        :articolo="articolo"
                        @UpdateCart = "this.$emit('UpdateCart')"
                    >
                    </CatalogCartRow>
                </tbody>
            </table>
        </div>
        <div class="OrderResumeBox">
            <div class="OrderResumeImage"><router-link :to="{'name':'CatalogProducts', 'params' : {'idCatalog' : this.catalog.IdCatalogo} }"><img :src="this.getUrlImmagineFull(this.catalog.UrlImmagine,true)" alt="" /></router-link></div>
            <div class="OrderResumeInfo">
                <div class="OrderResumeTableLabel">
                    <div class="OrderResumeTableLabelText">
                        <div><span>{{ this.risorse["CatalogoPart"] }} {{ this.catalog.Descrizione}}</span> <span>{{ this.risorse["OrdinePart"] }}</span></div>
                        <div><span></span> <span>*{{this.risorse["SpSped"]}}</span></div>
                    </div>
                </div>
                <div class="OrderResumeTableCosts">
                    <div>{{this.simboloValuta}} {{this.formatNumber((this.prezzoTotaleCatalogo ), 2, ',', '.')}}</div>
                    <div>{{this.simboloValuta}} {{this.formatNumber((this.SpeseSpedizioneCatalogo ), 2, ',', '.')}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="WhiteSpace">&nbsp;</div>
    </template>

    <script>
    import CatalogCartRow from "@/components/CatalogCartRow.vue";
    import {priceMixin, imgMixin, valutaMixin, risorseMixin} from "@/mixin.js";

    export default {
        name: "CatalogCart",
        props: {
            catalog: Object,
            listaArticoli: Array
        },
        components:{
            CatalogCartRow
        },
        emits:['UpdateCart'],
        computed:{
            prezzoTotaleCatalogo: function(){
                let totaleCatalogo = 0;
                this.listaArticoli.forEach(element => {
                    totaleCatalogo += element.PrezzoTotale;
                });
                return totaleCatalogo;
            },
            getUrlCatalogo: function(){
                return "/#/"
            },
            SpeseSpedizioneCatalogo: function(){
                let sp = this.$store.getters.getSpSpedizione?.CataloghiSpese;
                if(sp != null && sp.length > 0){
                    let v = sp.find( x => x.CodiceCatalogo == this.catalog.IdCatalogo);
                    return v?.SpeseSpedizione ?? 0;
                }else{
                    return 0;
                }
            }
        },
        mixins: [priceMixin, imgMixin, valutaMixin, risorseMixin]
    }
    </script>